import { render, staticRenderFns } from "./SectionTimer.vue?vue&type=template&id=14408dd4&scoped=true"
import script from "./SectionTimer.vue?vue&type=script&lang=ts"
export * from "./SectionTimer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14408dd4",
  null
  
)

export default component.exports